import { send_request } from '../../../utils/Request';

/**
 * Terminates multiple sessions by calling the terminate API endpoint for each session
 * @param {string[]} sessionIds - Array of session IDs to terminate
 * @param {boolean} isTestData - Whether we're working with test data
 * @returns {Promise} - Promise that resolves when all sessions are terminated
 */
export const terminateMultipleSessions = async (sessionIds, isTestData) => {
  if (!sessionIds || sessionIds.length === 0) return [];

  try {
    // Call the terminate API for each session
    const results = await Promise.all(
      sessionIds.map(sessionId =>
        send_request(
          `project-service/project/terminate/${sessionId}`,
          '',
          { isTest: isTestData },
          'post'
        )
      )
    );
    return results;
  } catch (error) {
    console.error('Error terminating sessions:', error);
    throw error;
  }
};

/**
 * Updates local state to reflect terminated sessions
 * @param {Array} data - Current session data array
 * @param {string[]} sessionIds - Array of session IDs that were terminated
 * @returns {Array} - Updated session data with terminated status
 */
export const updateTerminatedSessionsState = (data, sessionIds) => {
  if (!data || !sessionIds || sessionIds.length === 0) return data;

  const updatedData = [...data];

  for (const sessionId of sessionIds) {
    const sessionIndex = updatedData.findIndex(session => session.projectSessionId === sessionId);

    if (sessionIndex !== -1) {
      const session = { ...updatedData[sessionIndex] };
      session.status = 'TERMINATED';

      // Terminate all waiting components
      if (session.components && session.components.length > 0) {
        session.components = session.components.map(component => {
          if (
            (component.type === 'sequential_form' ||
              component.type === 'time_delay' ||
              component.type === 'form_section') &&
            component.status === 'WAITING'
          ) {
            return { ...component, status: 'TERMINATED' };
          }
          return component;
        });
      }

      updatedData[sessionIndex] = session;
    }
  }

  return updatedData;
};
